<template>

<b-modal :id="`patientModal-${key}`" :title="title" no-close-on-backdrop hide-footer>

	<PatientForm :id="id" @created="upserted" @updated="upserted" @close="close" @deleted="deleted"/>
	
</b-modal>

</template>

<script>
import PatientForm from './PatientForm'

export default {
	name: 'PatientModalForm',
	components:{
		PatientForm,
	},
	data() {
		return {
			title: 'Crear paciente',
			id: null,
			key: Math.random()
		}
	},
	methods:{
		upserted(data){
			this.$emit('upserted', data)
			this.close()
		},
		deleted(){
			this.$emit('deleted')
			this.close()
		},
		open(id){
			if(id) this.title = 'Editar paciente'
			this.id = id
			this.$bvModal.show(`patientModal-${this.key}`)
		},

		close(){
			this.id = null
			this.$bvModal.hide(`patientModal-${this.key}`)
		},

	}
}


</script>

<style>

</style>
